export default __webpack_public_path__ + "static/media/Cloak of Wakening Nightmares.c97d0d28.jpg";